import { Typography } from "@/components/common/Typography/Typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { classNames } from "@/utils/classNames"
import { IconCloudUpload } from "@tabler/icons-react"

interface DataRoomDropzoneProps {
  onPick: () => void
  /** Human-readable supported formats line, already translated. */
  formatsLabel?: string
  /** Optional context line, e.g. the seeded folder's description. */
  description?: string | null
}

/** The empty-folder invitation. Dropping itself is handled by the page-wide
 * overlay; this surface explains and offers the picker. */
export const DataRoomDropzone: React.FC<DataRoomDropzoneProps> = ({
  onPick,
  formatsLabel,
  description,
}) => {
  const { translate } = useTranslation()

  return (
    <button
      type="button"
      onClick={onPick}
      data-testid="data-room-dropzone"
      className={classNames(
        "animate-in fade-in group flex w-full flex-col items-center justify-center rounded-xl border border-dashed border-grey4/70 px-6 py-16 text-center duration-300",
        "transition-colors hover:border-grey5 hover:bg-grey2/40 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
      )}
    >
      <IconCloudUpload
        size={28}
        className="mb-4 text-grey5 transition-colors group-hover:text-white"
        aria-hidden="true"
      />
      <Typography as="span" variant="textM-bold">
        {translate("DATA_ROOM/DROPZONE_TITLE")}
      </Typography>
      {description && (
        <Typography
          as="span"
          variant="textS"
          className="mt-1.5 max-w-md text-grey5"
        >
          {description}
        </Typography>
      )}
      {formatsLabel && (
        <Typography as="span" variant="textXS" className="mt-6 text-grey5">
          {formatsLabel}
        </Typography>
      )}
    </button>
  )
}
